<template>
  <v-dialog v-model="dialog" max-width="600px" class="massupdate" eager>
    <v-card>
      <v-card-title>
        <span class="text-h5">{{ $t("view.operativos.campana.massupdate.title") }}</span>
        <v-spacer />
        <v-btn fab small color="primary" class="btn_tippy" elevation="0" :title="$t('view.commons.close')" @click="dialog = false">
          <v-icon small>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pb-0">
        <v-container fluid grid-list-md class="px-0 py-0 massupdate-dialog">
          <form id="massupdate">
            <v-layout row wrap>
              <!-- Vendor -->
              <v-flex xs12>
                <v-autocomplete
                  v-model.trim="massupdate.vendor"
                  :label="$t('view.operativos.campana.form.vendor.label')"
                  :items="view.elem.select.vendor.filteredList"
                  :disabled="view.action.submit.busy"
                  item-value="code"
                  item-text="name"
                  hide-selected
                  clearable
                  :no-data-text="$t('view.commons.nodata')" />
              </v-flex>

              <!-- Fecha Limite Campanas Process -->
              <v-flex xs12>
                <label for="dateresini" class="v-label mt-3">{{ $t("view.operativos.campana.form.dateres.label") }}</label>
                <v-layout row>
                  <v-flex md6>
                    <datePicker
                      ref="datePickerDateResIni"
                      :key="refreshkey"
                      :name="'dateresini'"
                      :label="$t('view.commons.dateIni')"
                      :value.sync="massupdate.dateresini"
                      :disabled="view.action.submit.busy"
                      @changeDate="changeDate" />
                  </v-flex>
                  <v-flex md6>
                    <datePicker
                      ref="datePickerDateResend"
                      :key="refreshkey"
                      :name="'dateresend'"
                      :label="$t('view.commons.dateEnd')"
                      :value.sync="massupdate.dateresend"
                      :disabled="view.action.submit.busy"
                      :min="massupdate.dateresini"
                      :enable-today="new Date(massupdate.dateresini) <= new Date()"
                      @changeDate="changeDate" />
                  </v-flex>
                </v-layout>
              </v-flex>

              <!-- Fecha Limite Campanas (Informativos) -->
              <v-flex xs12>
                <label for="datelimini" class="v-label mt-3">{{ $t("view.operativos.campana.form.datelim.label") }}</label>
                <v-layout row>
                  <v-flex md6>
                    <datePicker
                      ref="datePickerDateLimIni"
                      :key="refreshkey"
                      :name="'datelimini'"
                      :label="$t('view.commons.dateIni')"
                      :value.sync="massupdate.datelimini"
                      :disabled="view.action.submit.busy"
                      @changeDate="changeDate" />
                  </v-flex>
                  <v-flex md6>
                    <datePicker
                      ref="datePickerDateLimend"
                      :key="refreshkey"
                      :name="'datelimend'"
                      :label="$t('view.commons.dateEnd')"
                      :value.sync="massupdate.datelimend"
                      :disabled="view.action.submit.busy"
                      :min="massupdate.datelimini"
                      :enable-today="new Date(massupdate.datelimini) <= new Date()"
                      @changeDate="changeDate" />
                  </v-flex>
                </v-layout>
              </v-flex>

              <!-- Cuota Simple -->
              <v-flex md3>
                <label for="cuotasimple" class="v-label mt-3">{{ $t("view.operativos.campana.form.cuotasimple.label") }}</label>
                <v-autocomplete
                  v-model.trim="massupdate.cuotasimple"
                  :items="view.elem.select.cuotasimple.filteredList"
                  :disabled="view.action.submit.busy"
                  item-value="code"
                  item-text="name"
                  hide-selected
                  clearable
                  :no-data-text="$t('view.commons.nodata')" />
              </v-flex>

              <!-- Benef Pref -->
              <v-flex md3>
                <label for="benefpref" class="v-label mt-3">{{ $t("view.operativos.campana.form.benefpref.label") }}</label>
                <v-autocomplete
                  v-model.trim="massupdate.benefpref"
                  :items="view.elem.select.benefpref.filteredList"
                  :disabled="view.action.submit.busy"
                  item-value="code"
                  item-text="name"
                  hide-selected
                  clearable
                  :no-data-text="$t('view.commons.nodata')" />
              </v-flex>

              <!-- Contact Pref -->
              <v-flex md3>
                <label for="contactpref" class="v-label mt-3">{{ $t("view.operativos.campana.form.contactpref.label") }}</label>
                <v-autocomplete
                  v-model.trim="massupdate.contactpref"
                  :items="view.elem.select.contactpref.filteredList"
                  :disabled="view.action.submit.busy"
                  item-value="code"
                  item-text="name"
                  hide-selected
                  clearable
                  :no-data-text="$t('view.commons.nodata')" />
              </v-flex>

              <!-- OOB -->
              <v-flex md3>
                <label for="oob" class="v-label mt-3">{{ $t("view.operativos.campana.form.oob.label") }}</label>
                <v-autocomplete
                  v-model.trim="massupdate.oob"
                  :items="view.elem.select.oob.filteredList"
                  :disabled="view.action.submit.busy"
                  item-value="code"
                  item-text="name"
                  hide-selected
                  clearable
                  :no-data-text="$t('view.commons.nodata')" />
              </v-flex>

              <!-- Estatus -->
              <v-flex md3>
                <label for="status" class="v-label mt-3">{{ $t("view.commons.status") }}</label>
                <v-autocomplete
                  v-model.trim="massupdate.status"
                  :items="view.elem.select.status.filteredList"
                  :disabled="view.action.submit.busy"
                  item-value="code"
                  item-text="name"
                  hide-selected
                  clearable
                  :no-data-text="$t('view.commons.nodata')" />
              </v-flex>
            </v-layout>
          </form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-flex shrink>
          <v-btn id="btnclear" fab small color="primary" class="btn_tippy" elevation="0" :title="$t('view.commons.cancel')" :loading="view.action.submit.busy" @click="clear()">
            <v-icon small>fa-eraser</v-icon>
          </v-btn>

          <v-btn
            v-show="$userPermission.hasPermission('ROLE_MODIFICAR_OP')"
            id="btnsubmit"
            fab
            small
            color="primary"
            class="btn_tippy"
            elevation="0"
            :title="$t('view.commons.update')"
            :loading="view.action.submit.busy"
            :disabled="form.$state.isDisableButtonSubmit()"
            @click="submit()">
            <v-icon small>button__icon icon fas fa-check</v-icon>
          </v-btn>
        </v-flex>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import massupdateStates from "@/views/operativos/campana/massupdate/massupdate-state"; /** *******************************/
import DatePicker from "@/components/forms/DatePicker"; /** *******************************/
import { handleResponse } from "@/helpers/http-response-handler";
import { modelIsModified } from "@/helpers/vue-mc";
import { clearSwal, massUpdateSwal } from "@/constants/sweet-alerts";
import { submit_modal } from "@/constants/buttons";
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import tippy from "tippy.js";

const sino = [
  { code: "true", name: "SI" }
  , { code: "false", name: "NO" }
];

const oob = [
  { code: "true", name: "ACTIVO" }
  , { code: "false", name: "INACTIVO" }
];

const activo = [
  { code: "true", name: "ACTIVO" }
  , { code: "false", name: "INACTIVO" }
];

const select = {
  vendor: {
    completeList: []
    , filteredList: []
  }
  , cuotasimple: { filteredList: sino }
  , benefpref: { filteredList: sino }
  , contactpref: { filteredList: sino }
  , oob: { filteredList: oob }
  , status: { filteredList: activo }
};

const action = { submit: { busy: false } };

export default {
  name: "MassUpdateModal"
  , components: { DatePicker }
  , props: {
    search: {
      default: ""
      , type: String
    }
    , headers: {
      default: undefined
      , type: Array
    }
  }
  , data() {
    return {
      massupdate: undefined
      , filters: {}
      , dialog: false
      , init: false
      , form: new Object()
      , refreshkey: 0
      , view: {
        action
        , elem: {
          button: { submit: submit_modal }
          , select
        }
      }
    };
  }
  , async created() {
    this.form = new massupdateStates(this);
    this.form.$setState("initial");
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
    });
  }
  , updated() {
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
    });
  }
  , methods: {
    async submit() {
      try {
        const response = await this.form.$state.submit(this.massupdate);
        if (response && response.data && response.data.data && response.data.data.length > 0) {
          this.close();
          this.$emit("refresh");

          setTimeout(async () => {
            document.body.click();
            const { total, totalError, totalOk, totalUpdate, duration } = response.data.data[0];

            if (totalError > 0) massUpdateSwal.type = "warning";

            massUpdateSwal.html = `
              Registros seleccionados:&nbsp;&nbsp;&nbsp;<b>${total}</b><br>
              Registros actualizados:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>${totalUpdate}</b><br>
              Registros sin cambios:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>${totalOk - totalUpdate}</b><br>
              Registros con Errores:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>${totalError}</b><br><br>
              Duración:&nbsp;<b>${duration}</b>`;

            if (!(await this.$swal(massUpdateSwal)).value) return true;
          }, 500);
        } else {
          EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "MU5005", this.$t("view.operativos.campana.errors.MU5005.text"));
        }
      } catch (error) {
        console.error(error);
        handleResponse(error, this.$t("view.operativos.campana.errors"));
        this.close();
      }
    }
    , changeDate(field, value) {
      this.massupdate[field] = value;
    }
    , async open(filtros) {
      this.init = true;
      await this.form.$state.clear();
      this.filters = filtros;
      console.log("open: ", JSON.stringify(this.filters));
      this.dialog = true;
    }
    , async close() {
      if (this.view.action.submit.busy) return true;
      if (modelIsModified(this.massupdate) && !(await this.$swal(clearSwal)).value) return true;
      this.init = false;
      this.form.$state.clear();
      this.dialog = false;
    }
    , async clear() {
      this.form.$state.clear();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.v-dialog__content {
  z-index: 10000;
}
.entrevista .v-card__title {
  padding: 16px 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/operativos/campana/massupdate/MassUpdateModal.vue